module.exports = __webpack_public_path__ + "img/logo_title.fa37e71b.png";